import { useEffect, useState } from "react";
import axios from "axios";
const API = "/api";
export default function Banners() {
  const [promo, setPromo] = useState({ contenido: "", activo: true });
  const [infobar, setInfobar] = useState({ contenido: "", activo: true });
  const [guardandoPromo, setGuardandoPromo] = useState(false);
  const [guardandoInfobar, setGuardandoInfobar] = useState(false);
  const [msgPromo, setMsgPromo] = useState("");
  const [msgInfobar, setMsgInfobar] = useState("");
  const token = localStorage.getItem("token");
  const headers = { Authorization: "Bearer " + token };
  useEffect(() => {
    axios.get(API + "/banners/promo").then(r => {
      if (r.data) setPromo({ contenido: r.data.contenido || "", activo: r.data.activo ?? true });
    }).catch(() => {});
    axios.get(API + "/banners/infobar").then(r => {
      if (r.data) setInfobar({ contenido: r.data.contenido || "", activo: r.data.activo ?? true });
    }).catch(() => {});
  }, []);
  const guardarPromo = async () => {
    setGuardandoPromo(true);
    try {
      await axios.put(API + "/banners/promo", promo, { headers });
      setMsgPromo("Guardado correctamente");
      setTimeout(() => setMsgPromo(""), 3000);
    } catch { setMsgPromo("Error al guardar"); }
    setGuardandoPromo(false);
  };
  const guardarInfobar = async () => {
    setGuardandoInfobar(true);
    try {
      await axios.put(API + "/banners/infobar", infobar, { headers });
      setMsgInfobar("Guardado correctamente");
      setTimeout(() => setMsgInfobar(""), 3000);
    } catch { setMsgInfobar("Error al guardar"); }
    setGuardandoInfobar(false);
  };
  const card: React.CSSProperties = { background: "#fff", borderRadius: "16px", padding: "28px", boxShadow: "0 2px 12px rgba(0,0,0,0.06)", marginBottom: "24px" };
  return (
    <div>
      <div style={{ marginBottom: "28px" }}>
        <h1 style={{ fontFamily: "Montserrat,sans-serif", fontSize: "24px", fontWeight: 900, color: "#0D47A1", margin: 0 }}>Banners</h1>
        <p style={{ color: "#6b7280", marginTop: "6px", fontSize: "14px" }}>Administra los mensajes que aparecen en la pagina publica</p>
      </div>
      <div style={card}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "16px" }}>
          <span style={{ fontSize: "24px" }}>🎉</span>
          <div>
            <h2 style={{ fontFamily: "Montserrat,sans-serif", fontWeight: 800, fontSize: "16px", margin: 0 }}>Banner de Promocion</h2>
            <p style={{ color: "#6b7280", fontSize: "13px", margin: "2px 0 0" }}>Aparece en la parte superior. Ideal para ofertas y anuncios.</p>
          </div>
        </div>
        <div style={{ background: "linear-gradient(135deg,#1565C0,#0D47A1)", borderRadius: "10px", padding: "14px 20px", marginBottom: "16px", textAlign: "center" }}>
          <span style={{ color: "#fff", fontFamily: "Montserrat,sans-serif", fontWeight: 800, fontSize: "15px" }}>{promo.contenido || "Vista previa del mensaje..."}</span>
        </div>
        <label style={{ display: "block", fontSize: "13px", fontWeight: 700, color: "#374151", marginBottom: "6px" }}>Mensaje</label>
        <textarea value={promo.contenido} onChange={e => setPromo({ ...promo, contenido: e.target.value })} rows={3}
          placeholder="Ej: Oferta especial este fin de semana - 20% de descuento"
          style={{ width: "100%", border: "2px solid #e5e7eb", borderRadius: "10px", padding: "12px", fontSize: "14px", fontFamily: "Nunito,sans-serif", resize: "vertical", boxSizing: "border-box", outline: "none" }} />
        <div style={{ display: "flex", alignItems: "center", gap: "16px", marginTop: "14px", flexWrap: "wrap" }}>
          <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontSize: "14px", fontWeight: 600 }}>
            <input type="checkbox" checked={promo.activo} onChange={e => setPromo({ ...promo, activo: e.target.checked })} style={{ width: "18px", height: "18px" }} />
            Mostrar en la pagina
          </label>
          <button onClick={guardarPromo} disabled={guardandoPromo}
            style={{ background: "#0D47A1", color: "#fff", border: "none", borderRadius: "10px", padding: "10px 24px", fontWeight: 800, fontSize: "14px", cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
            {guardandoPromo ? "Guardando..." : "Guardar"}
          </button>
          {msgPromo && <span style={{ color: msgPromo.includes("Error") ? "#ef4444" : "#22c55e", fontWeight: 700 }}>{msgPromo}</span>}
        </div>
      </div>
      <div style={card}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "16px" }}>
          <span style={{ fontSize: "24px" }}>🚚</span>
          <div>
            <h2 style={{ fontFamily: "Montserrat,sans-serif", fontWeight: 800, fontSize: "16px", margin: 0 }}>Barra de Informacion (animada)</h2>
            <p style={{ color: "#6b7280", fontSize: "13px", margin: "2px 0 0" }}>Barra roja deslizante. Separa mensajes con el simbolo |</p>
          </div>
        </div>
        <div style={{ background: "#E53935", borderRadius: "10px", padding: "10px 20px", marginBottom: "16px", overflow: "hidden" }}>
          <div style={{ display: "flex", gap: "40px", color: "#fff", fontFamily: "Montserrat,sans-serif", fontWeight: 700, fontSize: "13px" }}>
            {(infobar.contenido || "Vista previa...").split("|").map((t: string, i: number) => (
              <span key={i} style={{ whiteSpace: "nowrap" }}>◆ {t.trim()}</span>
            ))}
          </div>
        </div>
        <label style={{ display: "block", fontSize: "13px", fontWeight: 700, color: "#374151", marginBottom: "6px" }}>Mensajes (separados por |)</label>
        <textarea value={infobar.contenido} onChange={e => setInfobar({ ...infobar, contenido: e.target.value })} rows={3}
          placeholder="Ej: Envios los Viernes y Sabados | Pedidos por WhatsApp | Entrega en todo el pais"
          style={{ width: "100%", border: "2px solid #e5e7eb", borderRadius: "10px", padding: "12px", fontSize: "14px", fontFamily: "Nunito,sans-serif", resize: "vertical", boxSizing: "border-box", outline: "none" }} />
        <div style={{ display: "flex", alignItems: "center", gap: "16px", marginTop: "14px", flexWrap: "wrap" }}>
          <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontSize: "14px", fontWeight: 600 }}>
            <input type="checkbox" checked={infobar.activo} onChange={e => setInfobar({ ...infobar, activo: e.target.checked })} style={{ width: "18px", height: "18px" }} />
            Mostrar en la pagina
          </label>
          <button onClick={guardarInfobar} disabled={guardandoInfobar}
            style={{ background: "#E53935", color: "#fff", border: "none", borderRadius: "10px", padding: "10px 24px", fontWeight: 800, fontSize: "14px", cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
            {guardandoInfobar ? "Guardando..." : "Guardar"}
          </button>
          {msgInfobar && <span style={{ color: msgInfobar.includes("Error") ? "#ef4444" : "#22c55e", fontWeight: 700 }}>{msgInfobar}</span>}
        </div>
        <div style={{ marginTop: "16px", background: "#f0f9ff", borderRadius: "8px", padding: "12px 16px", fontSize: "13px", color: "#0369a1" }}>
          <strong>Tip:</strong> Ejemplo: <code>Envios Viernes y Sabados | Pagos por SINPE | Garantia en todos los productos</code>
        </div>
      </div>
    </div>
  );
}